<template>
  <div style="display: flex; padding-top: 5px">
    <ejs-radiobutton
      ref="isInstallationTank"
      class="isInstallationTank"
      :name="ascaTankNumber"
      label="Installation"
      :checked="isInstallationTank"
      :disabled="disabled"
    />
    <div style="padding-left: 20px">
      <ejs-radiobutton
        ref="isRemovalTank"
        class="isRemovalTank"
        :name="ascaTankNumber"
        label="Removal"
        :checked="isRemovalTank"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioButtonTankInfoTemplate',
  props: {
    isInstallationTank: {
      type: Boolean,
      default: false,
    },
    ascaTankNumber: {
      type: String,
      default: 'default',
    },
    isRemovalTank: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: {},
    };
  },
};
</script>
